














































import { Component, Vue } from 'vue-property-decorator';
import GameLogic from "@/services/GameLogic";
import LocaleText from '@/components/LocaleText.vue';
import {EndVideoInfo} from "../store/ContentTypes";
import FeedbackLayout from "./components/FeedbackLayout.vue";
import {DelierState} from "../store/store";
import VideoPlayer from '@/components/VideoPlayer.vue';

@Component({
    data() { return { currentVideoIndex: 0, showVideo: false }},
    components: {FeedbackLayout, LocaleText, VideoPlayer},
    computed: {
        currentVideoThumbnail():string {
            let index:number = this.$data.currentVideoIndex;
            let all:EndVideoInfo[] = this.$store.state.endFeedback;
            if( index >= 0 && index < all.length )
            {
                return all[index].assets.imageURL.replace('shared/', 'images/endvideo/');
            }
            return '';
        },
        currentVideoTitle():string {
            let index:number = this.$data.currentVideoIndex;
            let all:EndVideoInfo[] = this.$store.state.endFeedback;
            if( index >= 0 && index < all.length )
            {
                return all[index].title;
            }
            return '';
        },
        currentVideo():string {
            let state:DelierState = this.$store.state;
            let index:number = this.$data.currentVideoIndex;
            let all:EndVideoInfo[] = state.endFeedback;
            if( index >= 0 && index < all.length )
            {
                return ['', state.locale, 'video', all[index].assets.videoURL.replace('.flv', '.mp4')].join('/');
            }
            return '';
        },
        getTips():string[] {
            let state:DelierState = this.$store.state;
            let result:string[] = [];
            for (let tipId in state.endTips) {
                result.push(tipId);
            }
            return result;
        }
    },
    methods: {
        handleClose(): void {
            window.close();
        },
        handleRestart():void {
            this.$store.commit('resetGame');
            this.$store.commit('startDay');
            this.$router.push('/');
        },
        handlePrevious():void {
            if (this.$data.currentVideoIndex > 0) {
                this.$data.currentVideoIndex = this.$data.currentVideoIndex - 1;
            }
        },
        handleNext():void {
            let all:EndVideoInfo[] = this.$store.state.endFeedback;
            if (this.$data.currentVideoIndex < all.length - 1 ) {
                this.$data.currentVideoIndex = this.$data.currentVideoIndex + 1;
            }
        },
        handleVideoCompleted():void {
            this.$data.showVideo = false;
        }
    },
    created():void {
        this.$store.state.endFeedback = GameLogic.processEndFeedback(this.$store.state);
    }
})
export default class EndPage extends Vue {}
